import React, {useState} from 'react';
import PropTypes from 'prop-types';
import WorkIcon from '@material-ui/icons/Work';
import { SignInAPIReq, SignUpAPIReq, SignInOfficeAPIReq } from 'utils/requests'
import Cookies from 'universal-cookie';
import  { Redirect } from 'react-router-dom'
import { Route , withRouter} from 'react-router-dom';

const cookies = new Cookies();


let isLoading = true;

function useForceUpdate(){
  const [value, setValue] = useState(0); // integer state
  return () => setValue(value => ++value); // update the state to force render
}

// const SignIn = (id) =>{
//   if(isLoading){
//     return SignInOfficeAPIReq(id)
//       .then((res) => {
//         if(res[0] && res[1]){
//           history.push('/offers');
//         } else{
//           alert('An arror happened while fetching for data');
//         }
//       })
//   }
// }

// const SignIn = (id) => {
//   return SignInOfficeAPIReq(id)
//       .then(res=>{
//         console.log(res)
//         if(res) {
//           value = true
//         }else{
//           alert('Wrong Credentials');
//         }
//       })
// }

let data;
const HandleLogin = props => {
  const { className, history, accountInfo, ...rest } = props;
  let id = accountInfo.account.name.split('<').pop().split('>')[0]
  id = id.replace(/\s/g, "");

  function SignIn(id) {
    return SignInOfficeAPIReq(id)
      .then((res) => {
        if(res.status === 'registered') {
          cookies.set('auth', res.data[0], { path: '/' });
          history.push('/offers');
        } else if (res.status === 'success'){
          if (res.data.is_registered === false) {
            history.push({
              pathname: '/additional',
              state: {accountInfo}
            });
          }
        }
        else if (res.status === 'fail') {
          if (res.error.code === 3){
            history.push({
              pathname: '/beta',
              state: {error: res.error.message + ' (' + res.error.code + ')'}
            })
          } else if (res.error.code === 100){
            history.push({
              pathname: '/additional',
              state: {accountInfo}
            });
          }
        } else {
          history.push('/non');
        }
      })
  }

  SignIn(id)

  return (
    <div>

    </div>
  )


  // SignIn(accountInfo.account.name.split('<').pop().split('>')[0])
};

HandleLogin.propTypes = {
  className: PropTypes.string,
  accountInfo: PropTypes.any
};

export default withRouter(HandleLogin);
